import React, {Component} from 'react'
import CalculatorTermForm from "./term.component.jsx"
import {FormattedMessage} from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx"
const uuidv4 = require('uuid/v4')

class CalculatorTermsForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            list: this.props.value || []
        }
        this.deleteItem = this.deleteItem.bind(this)
        this.addItem = this.addItem.bind(this)
        this.changeItem = this.changeItem.bind(this)
    }

    componentDidMount() {
        this.setState({
            list: this.props.value || []
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            list: nextProps.value || []
        })
    }

    deleteItem(index) {
        this.setState({
            list: this.state.list.filter((_, i) => i != index)
        }, () => {
            this.onChange()
        })
    }

    changeItem(index, value) {
        const list = this.state.list
        list[index] = value
        this.setState({
            list: list
        }, () => {
            this.onChange()
        })
    }

    addItem(e) {
        e.preventDefault()
        const list = this.state.list

        list.push({
            name: '',
            description: '',
            calculatorTermId: uuidv4(),
            variableName: 'var_' + list.length,
            simulation: '',
        })
        this.setState({
            list: list
        }, () => {
            this.onChange()
        })
    }

    onChange() {
        const onChange = this.props.onChange || function () {}
        onChange(this.state.list)
    }

    render() {
        return (
            <div>
                {this.state.list.map((value, index) => {
                    return <CalculatorTermForm
                        key={'calculator-term-' + index}
                        value={value}
                        index={index}
                        onDelete={this.deleteItem}
                        onChange={this.changeItem}
                    />
                })}
                <div className="row pt-3">
                    <div className="col-12">
                        <button className="btn btn-primary btn-sm" onClick={this.addItem}>
                            <Icon value={"plus-circle"}/>
                            <FormattedMessage
                                id="product.edit.form.calculator.term.add_term_btn"
                                defaultMessage="Add a parameter"
                            />
                        </button>
                    </div>
                </div>
            </div>

        );
    }
}

export default CalculatorTermsForm


// WEBPACK FOOTER //
// ./src/product/form/calculator/terms.component.jsx